// ════════════════════════════════════════════════════════════════
// COSTY — Toast Notifications (compat shim)
// ────────────────────────────────────────────────────────────────
// The toast UI is the <costy-toast> Lit component
// (src/components/costy-toast.ts) shipped in Phase B PR 6, which
// replaced the earlier <fc-toast>. This file is the thin re-export
// so every call site keeps importing `showToast` from './toast.js'
// without change.
//
// Legacy variant names ('green' / 'red' / 'amber') translate to the
// redesign palette ('success' / 'error' / 'warning'). The 'info'
// variant has no legacy alias — direct callers pass it through.
// ════════════════════════════════════════════════════════════════

import { showCostyToast } from './components/costy-toast.js';

/** @typedef {'green' | 'red' | 'amber' | 'success' | 'warning' | 'error' | 'info'} ToastVariant */
/** @typedef {{ label: string, onClick: () => void }} ToastAction */
/** @typedef {{ id?: number, duration?: number, action?: ToastAction }} ToastOptions */

const LEGACY_TO_REDESIGN = {
  green: 'success',
  red:   'error',
  amber: 'warning',
};

/**
 * Display a transient status toast.
 *
 * @param {string} message
 * @param {ToastVariant} [variant='green']
 * @param {ToastOptions} [options] optional id (in-place update), duration, or inline action button.
 * @returns {number} id of the notification, for future update/dismiss.
 */
export function showToast(message, variant = 'green', options = {}) {
  const mapped = LEGACY_TO_REDESIGN[variant] ?? variant;
  return showCostyToast(message, mapped, options);
}
